<template>
  <datetime
    type="datetime"
    input-id="startDate"
    v-model="date"
    :phrases="{ok: 'Continuer', cancel: 'Fermer'}"
    :minute-step="15"
    v-on:close="close"
    class="theme-orange"
    value-zone="Europe/Monaco"
    auto
  >
    <label
      for="startDate"
      v-bind:class="{ active: active }"
      slot="before"
    >Date et heure de livraison</label>
  </datetime>
</template>

<script>
import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";

export default {
  data: function() {
    return {
      active: false
    };
  },
  computed: {
    date: {
      get() {
        return this.$store.state.date;
      },
      set(value) {
        this.$store.commit("updateDate", value);
      }
    }
  },
  methods: {
    close: function() {
      this.active = true;
    }
  },
  components: { Datetime }
};
</script>

<style>
.theme-orange .vdatetime-popup__header,
.theme-orange .vdatetime-calendar__month__day--selected > span > span,
.theme-orange .vdatetime-calendar__month__day--selected:hover > span > span {
  background: #FF9800;
}

.theme-orange .vdatetime-year-picker__item--selected,
.theme-orange .vdatetime-time-picker__item--selected,
.theme-orange .vdatetime-popup__actions__button {
  color: #ff9800;
}
</style>
